<template>
	<div class="orderpage">
		<common-header></common-header>
		<div class="text-left flex border-top">
			<div class="left-menu">
				<ul class="side-nav">
					<li class="nav-item">
						<a>个人中心</a>
						<ul>
							<li class="nav-item"><el-link @click="toPage('/userManage')">个人中心</el-link></li>
						</ul>
					</li>
					<li class="nav-item">
						<a>订单中心</a>
						<ul>
							<li class="nav-item"><el-link @click="toPage('/order','state=1')">待付款</el-link></li>
							<li class="nav-item"><el-link @click="toPage('/order','state=2')">待发货</el-link></li>
							<li class="nav-item"><el-link @click="toPage('/order','state=3')">待评价</el-link></li>
							<li class="nav-item"><el-link @click="toPage('/order','state=4')">退款售后</el-link></li>
						</ul>
					</li>
				</ul>
			</div>
			<div class="right-container">
				<div class="page-title backcolor padding">收藏商品</div>
				<div class="order-container">
					<div class="guess" v-if="collectList.length">
						<div class="flex flex-start text-left">
							<img src="../../assets/temp/h1.png" />
							<div style="padding: 20px;">
								<p class="tit">收藏列表</p>
								<p class="tit2">Collect List</p>
							</div>
						</div>
						<div class="goods-item">
							<div class="section">
								<div class="section-item" v-for="(item, index) in collectList" :key="index" @click="toDetail(item.goods_id)">
									<div class="goods-pic"><img :src="getWebPic(item.smpic)" alt="" /></div>
									<p class="goods-title" :title="item.name">{{ item.name }}</p>
									<p class="text-right" style="margin-top: 7px;">
										<el-button icon="el-icon-star-off" size="mini" @click.stop="toFavorite(item)">取消关注</el-button>
									</p>
								</div>
							</div>
						</div>
					</div>
					<div v-else class="no-collect text-center backcolor">
						<img src="../../assets/no-order.png" >
						<div>暂无收藏商品<el-link style="margin-left: 10px;" @click="toPage('/home')">去逛逛>></el-link></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import commonHeader from '../../components/common/commonHeader.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
	name: '',
	components: {
		commonHeader
	},
	data() {
		return {
			thispage: 1,
			total: 0,
			pagesize: 30, //每页显示条数
			pageSizes: [30], //每页显示个数选择器
			collectList: []
		};
	},
	computed: {
		...mapState({
			loginState: state => state.user.loginState,
			userInfo: state => JSON.parse(state.user.userInfo)
		})
	},
	mounted() {
		this.getCollectList();
	},
	methods: {
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.pagesize = val;
			this.getCollectList();
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.thispage = val;
			this.getCollectList();
		},
		getCollectList() {
			this.$request
				.post('/home.user/collectList', {
					user_id: this.userInfo.id,
					userid: this.userInfo.id,
					token: this.userInfo.token,
				})
				.then(res => {
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'userinfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.collectList = res.data.list;
					}
				})
				.catch(err => {});
		},
		//删除订单
		deleteOrder(item) {
			this.$confirm('确定要取消订单吗？')
				.then(_ => {
					this.$emit('showLoading', true);
					this.$request
						.post('/home.order/deleteOrder', {
							userid: this.userInfo.id,
							token: this.userInfo.token,
							order_id: item.id,
							buyType: '' //区别于团购订单的
						})
						.then(res => {
							console.log(res.data);
							this.$emit('showLoading', false);
							this.$message.success(res.data.msg);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'userinfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.getCollectList();
							}
						})
						.catch(err => {
							this.$emit('showLoading', false);
						});
				})
				.catch(_ => {});
		},
		//收藏
		toFavorite(info) {
			this.$request.post('/home.user/goodsCollect',{
				user_id: this.userInfo.id,
				goods_id: info.goods_id,
				favorite: 0,
				userid: this.userInfo.id ? this.userInfo.id : '',
				token: this.userInfo.token ? this.userInfo.token : ''
			})
			.then(res=>{
				if (res.data.status == 0) {
					this.$message.error(res.data.msg);
					if (res.data.admin_err == 'userinfo_error') {
						this.exit().then(res => {
							console.log(res);
							if (res.actionStatus == 1) {
								this.$router.push('/login');
							}
						});
					}
				} else {
					this.$message.success(res.data.msg);
					this.getCollectList();
				}
			})
			.catch(err=>{
				
			})
		},
	}
};
</script>
<style lang="scss">
.el-main {
	.orderpage {
		background-color: #fff !important;
	}
	.left-menu {
		width: 170px;
		background-color: #fff;
		.side-nav {
			> .nav-item {
				padding: 15px 20px;
				border-bottom: 1px solid #f3f3f3;
				a {
					font-size: 15px;
					font-weight: bold;
					text-decoration: none;
					line-height: 40px;
				}
				.nav-item {
					a {
						font-size: 14px;
						line-height: 30px;
						&:hover {
							cursor: pointer;
						}
					}
				}
			}
		}
	}
	.right-container {
		flex: 1;
		padding: 20px 0 0 20px;
		background-color: #f0f3ef !important;
		.backcolor {
			background-color: #fff;
		}
		.padding {
			padding: 0 15px;
		}
		.page-title {
			line-height: 40px;
		}
		.order-container {
			margin-top: 15px;
			// margin-left: 15px;
			.menu-btn {
				button {
					color: dimgray;
					padding: 0 10px;
					line-height: 35px;
					&:hover {
						color: $base-color;
					}
					&.active {
						color: $base-color;
						border-bottom: 2px solid $base-color;
					}
				}
			}
			.order-item {
				margin-top: 10px;
				border: 1px solid #dddddd;
				.th {
					background-color: #e1e1e1;
					font-size: 14px;
					line-height: 35px;
					span + span {
						margin-left: 15px;
					}
				}
				.item-border {
					> div {
						border-right: 1px solid #dddddd;
						padding-top: 15px;
						text-align: center;
						&:first-child{
							padding:  0 15px;
							text-align: left;
						}
						&:first-child {
							padding-top: 0;
						}
						&:last-child {
							border-right: none;
						}
					}
				}
				.goods-info {
					flex: 1;
					.goods-item {
						border-bottom: 1px solid #dddddd;
						&:last-child {
							border: none;
						}
						padding: 15px 0;
						.smpic {
							width: 60px;
							height: 60px;
						}
						.goods-title {
							flex: 1;
							padding-left: 15px;
						}
						.param-num {
							padding: 0 15px;
							text-align: center;
							color: gray;
							font-size: 14px;
							line-height: 30px;
							.num {
								&::before {
									content: 'x';
									margin-right: 3px;
								}
							}
						}
					}
				}

				.user-address {
					width: 85px;
					line-height: 30px;
					&:hover {
						cursor: pointer;
					}
				}
				.order-pay {
					width: 90px;
					line-height: 30px;
					text-align: center;
					.pay {
						border-bottom: 1px solid #ccc;
						&::before {
							content: '￥';
						}
					}
				}
				.order-status{
					width: 82px;
				}
				.operate {
					width: 120px;
					text-align: center;
					.chaoshi_tip {
						font-size: 13px;
						color: #cccccc;
					}
					.block{
						display: block;
						+.block{
							margin-top: 10px;
						}
					}
					
				}
			}
		}
	}
	.border-top{
		border-top:1px solid #f3f3f3 ;
	}
}
</style>
